import maintenanceControlApi from '../../api/maintenanceControl';
import { HandoverReportConfig } from '../../components/Handover';

export const maintenanceControlHandoverConfig: HandoverReportConfig = {
    title: "Maintenance Control Handover Reports",
    dialogTitle: "Maintenance Control Handover",
    editGroup: "Maintenance Control Edit",
    employeeLabel: "Shift leaders",
    showFilters: true,
    // No print or email actions: those were asked for by Line Planner only, and the Email route
    // exists on the Line Planner controller alone. Both are one flag away if Maintenance
    // Control wants them.
    api: maintenanceControlApi,
};
